import styled from 'styled-components';

export default styled.div`
  box-shadow: 0px 6px 0px 0px #7faab2;
  transform: translate(-50%, -110%);

  background-color: #abe5f1;
  pointer-events: none;

  border-radius: 8px;
  text-align: center;
  position: absolute;

  font-size: 11px;
  display: block;
  padding: 8px;

  width: 73px;
  color: #000;

  bottom: 0;
  left: 50%;

  &::after,
  &::before {
    transform: translateY(95%);
    position: absolute;

    margin: 0 auto;
    content: '';

    height: 0px;
    width: 0px;

    bottom: 0;
    right: 0;
    left: 0;
  }

  &::before {
    border-right: 14px solid transparent;
    border-left: 14px solid transparent;
    border-top: 16px solid #abe5f1;

    z-index: 1;
  }

  &::after {
    border-right: 20px solid transparent;
    border-left: 20px solid transparent;
    border-top: 22px solid #7faab2;

    transform: translateY(100%);
  }
`;
